import moment from "moment";
import { getStockActivities } from "../../../utils/services/schedulingAndStock";
import { getGroups } from "../../../utils/services/group";

export const excelColumnsPtBr = {
  Sala: "room",
  Atividade: "task",
  "Data e Hora Inicio": "initialDate",
  "Data e Hora Fim": "endDate",
  "Quantidade Máxima": "maxQuantity",
  "Segregar Por Grupos": "segragate",
  "Grupos e Quantidades": "groups",
};

export const excelColumnsPtBrUpdate = {
  "ID do Estoque": "id",
  Sala: "room",
  Atividade: "task",
  "Data e Hora Inicio": "initialDate",
  "Data e Hora Fim": "endDate",
  "Quantidade Máxima": "maxQuantity",
  "Segregar Por Grupos": "segragate",
  "Grupos e Quantidades": "groups",
};

export const excelColumnsPtBrDelete = {
  "ID do Estoque": "id",
  Sala: "room",
  Atividade: "task",
};

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    room: row.room ? row.room : undefined,
    task: row.task ? row.task : undefined,
    initialDate:
      row.initialDate && row.initialDate != "Invalid Date"
        ? row.initialDate
        : undefined,
    endDate:
      row.endDate && row.endDate != "Invalid Date" ? row.endDate : undefined,
    maxQuantity: row.maxQuantity ? row.maxQuantity : undefined,
    tipo: row.tipo ? row.tipo : "",
    segragate: row.segragate,
    groups: row?.segragate?.toUpperCase() === "SIM" ? row.groups : "",
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    id: row.id,
    index,
    room: row.room ? row.room : undefined,
    task: row.task ? row.task : undefined,
    initialDate:
      row.initialDate && row.initialDate != "Invalid Date"
        ? row.initialDate
        : undefined,
    endDate:
      row.endDate && row.endDate != "Invalid Date" ? row.endDate : undefined,
    maxQuantity: row.maxQuantity ? row.maxQuantity : undefined,
    tipo: row.tipo ? row.tipo : "",
    segragate: row.segragate,
    groups: row?.segragate?.toUpperCase() === "SIM" ? row.groups : "",
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    id: row.id,
    index,
    room: row.room ? row.room : undefined,
    task: row.task ? row.task : undefined,
  };

  return formatedRow;
}

export async function findRowsWithError(validRows) {
  const rowsWithError = validRows.filter(
    (row) =>
      Object.values(row).filter((value) => value === undefined).length > 0
  );
  return rowsWithError;
}

export async function validateDuplicity(rows) {
  if (rows.length < 2) return [];

  var allRowsDuplicity = [];

  for (let i = 0; i < rows.length; ++i) {
    const row = rows[i];

    rows.map((e) => {
      // se for a mesma linha do for, é ignorada
      if (row.index === e.index) return;

      // validar se todos os itens são iguais, e se for, verificar se ja foi adicionado ao array de items duplicados
      if (
        e.room === row.room &&
        e.task === row.task &&
        moment(e.initialDate).format() === moment(row.initialDate).format() &&
        moment(e.endDate).format() === moment(row.endDate).format() &&
        e.maxQuantity === row.maxQuantity
      ) {
        allRowsDuplicity.push(e);
      }
    });
  }

  // remover duplicados e transformar em array
  const allRowsDuplicityFormated = Array.from(new Set(allRowsDuplicity));

  return allRowsDuplicityFormated;
}

export async function getValidStocks(stocks, jwt, idEvent) {
  try {
    const res = await getStockActivities(idEvent, jwt, 1, 9999, "", "sala");

    const listAllStocks = res.total > 0 ? res.data : [];

    var stocksNotFounds = [];

    for (const stock of stocks) {
      const search = listAllStocks.find((e) => e.id === stock.id);

      if (!search) {
        stocksNotFounds.push({
          ...stock,
          id: undefined,
        });
      }
    }

    return stocksNotFounds;
  } catch (error) {
    return [];
  }
}

export async function getValidsGroups(idEvent, rows) {
  const res = await getGroups({
    eventId: idEvent,
    offset: 1,
    limit: 10000,
    search: "",
  });

  const allGroups =
    res.findOneGroupData.count > 0 ? res.findOneGroupData.data : [];

  var groupsDoc = [];

  for (const row of rows) {
    const groups =
      row?.segragate?.toUpperCase() === "SIM"
        ? row.groups
            .split(",")
            .map((nome) => nome.trim())
            .map((e) => {
              const group = e.split("=")[0];
              const quantity = Number(e.split("=")[1]);

              return {
                group,
                quantity,
                index: row.index,
              };
            })
        : null;

    if (groups) {
      groupsDoc = [...groupsDoc, ...groups];
    }
  }

  var groupsInvalids = [];

  if (groupsDoc.length > 0) {
    groupsDoc.map((e) => {
      const search = allGroups.find((group) => group.name === e.group);

      // adicionar ao array de inválidos os objetos que não tenha ids iguais
      // aos ids dos grupos existentes e que o objeto não tenha sido incluido ainda
      if (
        (!search || !e.group || !e.quantity) &&
        !groupsInvalids.find((g) => g.index === e.index)
      )
        groupsInvalids.push({
          ...rows.find((r) => r.index === e.index),
          groups: undefined,
        });
    });
  }

  return groupsInvalids;
}

export async function formatGroups(row, idEvent) {
  const groups =
    row?.segragate?.toUpperCase() === "SIM"
      ? row.groups
          .split(",")
          .map((nome) => nome.trim())
          .map((e) => {
            const group = e.split("=")[0];
            const quantity = Number(e.split("=")[1]);

            return {
              group,
              quantity,
            };
          })
      : [];

  if (groups.length < 1) return groups;

  const res = await getGroups({
    eventId: idEvent,
    offset: 1,
    limit: 10000,
    search: "",
  });

  const allGroups =
    res.findOneGroupData.count > 0 ? res.findOneGroupData.data : [];

  var groupsFormateds = [];

  groups.map((e) => {
    const search = allGroups.find((g) => g.name === e.group);

    groupsFormateds.push({
      groupId: search?.id,
      quantidade: e.quantity,
    });
  });

  return groupsFormateds;
}
